import apiService from '../../services/api';

const actions = {
    byHour: (context, params) => {
        return apiService.get('statistic.byHour', params);
    },
    byDay: (context, params) => {
        return apiService.get('statistic.byDay', params);
    },
    byDate: (context, params) => {
        return apiService.get('statistic.byDate', params);
    },
    flex: (context, params) => {
        return apiService.get('statistic.flex', params);
    },
    byHistory: (context, params) => {
        return apiService.get('statistic.byHistory', params);
    }
};

export default {
    namespaced: true,
    actions
};
